export default {
  CONTENT_WIDTH: '115rem',
  FONT_FAMILY_1: 'Quantium',
  FONT_FAMILY_2: 'Roboto',
  FONT_SIZE_1: '4.2rem',
  FONT_SIZE_2: '2rem',
  FONT_WEIGHT_LIGHT: '300',
  FONT_WEIGHT_REGULAR: '400',
  FONT_WEIGHT_MEDIUM: '500',
  COLOR_WHITE_1: '#ffffff',
  COLOR_BLACK_1: '#000000',
  COLOR_GRAY_1: '#ede8e3',
  COLOR_GRAY_2: '#c7c6c4',
  COLOR_RED_1: '#f0523d',
  COLOR_TURQUOISE_1: '#00afb8',
  BORDER_RADIUS_1: '3px',
  BOX_SHADOW_1: 'rgba(0, 0, 0, 0.15) 0px 1px 3px 0px',
  TRANSITION_SETTINGS: '0.2s ease-out',
}
